import { ResponsiveBar } from '@nivo/bar';
import { TrendLine } from './trend-line';
import { utcToZone } from '../../utils/date/utcToZone';
import { useMemo } from 'react';

export function ConsumptionTrendAverageGraph({ data, resolution }: { data: any[]; resolution?: string }) {
  const maxValue = useMemo(() => {
    if (!data || data.length === 0) return undefined;
    return Math.max(...data.map((d) => Math.max(d.value ?? 0, d.trend ?? 0)));
  }, [data]);
  return (
    <div className="h-full">
      <ResponsiveBar
        data={data}
        indexBy="key"
        padding={0.6}
        enableLabel={false}
        animate={true}
        valueScale={{ type: 'linear', min: 0, max: maxValue ?? 'auto' }}
        colors={data.map((d) => d.color)}
        axisBottom={{
          format: (value: string) => {
            const date = utcToZone(value);
            switch (resolution) {
              case 'hourly':
                return date.format('HH:mm');
              case 'daily':
                return date.format('DD.MM');
              case 'weekly':
                return `${date.isoWeek()}`;
              case 'monthly':
                return date.format('M');
              case 'yearly':
                return date.format('YYYY');
              default:
                return value;
            }
          },
          tickSize: 5,
          tickPadding: 10,
          tickRotation: resolution === 'monthly' ? 0 : -45,
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
        }}
        theme={{
          grid: {
            line: {
              stroke: 'rgba(255, 255, 255, 0.2)',
            },
          },
          axis: {
            domain: {
              line: {
                strokeWidth: 0,
                stroke: 'rgba(0, 0, 0, 0)',
              },
            },
            ticks: {
              line: {
                strokeWidth: 0,
                stroke: 'rgba(0, 0, 0, 0)',
              },
              text: {
                fill: '#fff',
              },
            },
          },
        }}
        tooltip={() => null}
        layers={['grid', 'markers', 'axes', 'bars', (props) => <TrendLine {...props} data={data} />, 'legends']}
        margin={{ top: 10, right: 10, bottom: 50, left: 40 }}
      />
    </div>
  );
}
